class PurchaseOrderSuggestionController extends BaseController
	autoScopeInject: false

	@register angular.module 'App.Module.Controller'
	@inject 'PurchaseOrderRepository',
		'MessageTerminal'
		'MessageTypes'
		'DATE_FORMAT'

	initialize: ->
		@isLocked ?= false
		@filter ?= {}
		@shopsData = _.groupBy(@shops, 'stock_location_id')
		@shopsList = []
		@events = @MessageTypes.PURCHASE_ORDER
		@additionalProducts = []
		@loading = false

		@datePickerInfo =
			singleDatePicker: true
			startDate: moment().add(2, 'days')
			minDate: moment()

		if @stockLocations.length == 1
			@filter.stockLocationId = @stockLocations[0].id
			do @onStockLocationChange

	search: ->
		@loading = true

		query = @PurchaseOrderRepository.createQuery()
		query.addParameter 'stock_location_id', @filter.stockLocationId
		query.addParameter 'shop_id', @filter.shopId
		query.addParameter 'supplier_id', @filter.supplierId
		query.addParameter 'from', @filter.startTime
		query.addParameter 'to', @filter.endTime

		return @PurchaseOrderRepository
			.findByQuery query, '/suggested_products'
			.then (response) =>
				groupedData = _.chain(response.data)
					.map((item) -> _.omit(item, 'id'))
					.groupBy('product_id')
					.values()
					.value()

				@MessageTerminal.publish @events.REPORT_DATA, groupedData
			.finally =>
				@loading = false
				# Move to table directive
				angular.element('#report-table').animate({scrollTop: 0}, 150)

	onEndTimeChange: (endDateTimestamp) ->
		@filter.endTime = endDateTimestamp

	onStockLocationChange: ->
		@filter.shopId = null
		@shopsList = @shopsData[@filter.stockLocationId] ? []

		if !_.isEmpty(@shopsList)
			@filter.shopId = _.first(@shopsList).id
